if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-ri-sticky-atc-trigger]');
      /* System add-on forms come first in the page, so look for the main form by its button. */
      this.productForm =
        document.querySelector('[id^="ProductSubmitButton"]')?.form ||
        document.querySelector('form[id^="product-form-"][action*="/cart/add"]:not([id^="product-form-installment"])') ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('product-form form');
      this.buyButtons =
        document.querySelector('.product-form__buttons') ||
        document.querySelector('[id^="ProductSubmitButton"]')?.closest('.product-form');

      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onVariant = this.onVariant.bind(this);
      this.onCart = this.onCart.bind(this);
      this.onCartError = this.onCartError.bind(this);
      this.syncChoice = this.syncChoice.bind(this);

      if (this.trigger) this.trigger.addEventListener('click', this.onClick);
      this.querySelector('[data-ri-sticky-minus]')?.addEventListener('click', () => this.changeQty(-1));
      this.querySelector('[data-ri-sticky-plus]')?.addEventListener('click', () => this.changeQty(1));
      this.refreshQty();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('change', this.syncChoice);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant);
        this._unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCart);
        this._unsubError = subscribe(PUB_SUB_EVENTS.cartError, this.onCartError);
      }
      this.hidden = false;
      this.defaultLabel = (this.trigger && this.trigger.textContent.trim()) || 'Add to cart';
      this.syncChoice();
      this.onScroll();
      if (typeof ResizeObserver === 'function') {
        this._padObserver = new ResizeObserver(() => {
          this._padHeight = Math.ceil(this.getBoundingClientRect().height);
          this.applyPad();
        });
        this._padObserver.observe(this);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('change', this.syncChoice);
      if (this.trigger) this.trigger.removeEventListener('click', this.onClick);
      if (this._unsubVariant) this._unsubVariant();
      if (this._unsubCart) this._unsubCart();
      if (this._unsubError) this._unsubError();
      if (this._statusTimer) window.clearTimeout(this._statusTimer);
      if (this._padObserver) this._padObserver.disconnect();
      document.documentElement.style.setProperty('--ri-sticky-atc-pad', '0px');
    }

    onVariant(event) {
      const data = event && event.data;
      if (!data || !data.html) return;
      const priceSrc = data.html.getElementById(`price-${data.sectionId}`);
      const priceDest = this.querySelector('.ri-sticky-atc__price');
      if (priceSrc && priceDest) priceDest.innerHTML = priceSrc.innerHTML;
      const submit = data.html.getElementById(`ProductSubmitButton-${data.sectionId}`);
      const btn = this.querySelector('[data-ri-sticky-atc-trigger]');
      if (submit && btn) {
        btn.disabled = submit.hasAttribute('disabled');
        let label = '';
        submit.querySelectorAll('span').forEach((span) => {
          if (label) return;
          if (span.classList.contains('hidden')) return;
          if (span.querySelector('.loading__spinner, .path')) return;
          const text = span.textContent.replace(/\s+/g, ' ').trim();
          if (text) label = text;
        });
        if (label) {
          this.defaultLabel = label;
          if (!(this._qty > 0)) btn.textContent = label;
        }
      }
      this.syncChoice();
      this.refreshQty();
      this.onScroll();
    }

    syncChoice() {
      const el = this.querySelector('[data-ri-sticky-choice]');
      if (!el) return;
      const checked = document.querySelectorAll(
        '.product__info-container variant-selects input[type="radio"]:checked, .product__info-container variant-radios input[type="radio"]:checked'
      );
      const parts = [];
      checked.forEach((input) => {
        const value = (input.value || '').trim();
        if (value && value !== 'Default Title') parts.push(value);
      });
      el.textContent = parts.join(', ');
      el.hidden = parts.length === 0;
    }

    setStatus(message, kind) {
      const status = this.querySelector('[data-ri-sticky-status]');
      this.classList.remove('is-added', 'is-error', 'is-pending');
      if (kind) this.classList.add(kind);
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      const choice = this.querySelector('[data-ri-sticky-choice]');
      if (choice && message) choice.hidden = true;
      this.applyPad();
      if (this._statusTimer) window.clearTimeout(this._statusTimer);
      if (!message || kind === 'is-pending') return;
      this._statusTimer = window.setTimeout(() => {
        this.classList.remove('is-added', 'is-error');
        status.hidden = true;
        status.textContent = '';
        this.syncChoice();
        if (this.trigger && !(this._qty > 0) && this.defaultLabel) this.trigger.textContent = this.defaultLabel;
        this.applyPad();
      }, 2800);
    }

    onCart(event) {
      const fromSticky = this._pendingAdd && event && event.source === 'product-form';
      const cart = event && event.cartData;
      /* cart/add.js returns the line that was added, not the cart. Only a payload with items is a cart. */
      if (cart && Array.isArray(cart.items)) {
        this._qtyToken = (this._qtyToken || 0) + 1;
        this.applyQty(cart);
      } else {
        this.refreshQty();
      }
      if (!fromSticky) return;
      this._pendingAdd = false;
      const variantId = String((event && event.productVariantId) || this.variantId());
      const line =
        cart && Array.isArray(cart.items)
          ? cart.items.find((row) => String(row.variant_id) === variantId)
          : null;
      const choice =
        line && line.variant_title && line.variant_title !== 'Default Title'
          ? line.variant_title
          : this.choiceText();
      const message = choice ? 'Added. ' + choice + ' is in your cart.' : 'Added to your cart.';
      this.setStatus(message, 'is-added');
    }

    onCartError(event) {
      if (!this._pendingAdd) return;
      if (event && event.source && event.source !== 'product-form') return;
      this._pendingAdd = false;
      const message = (event && (event.message || event.errors)) || 'Not added. Try again.';
      if (this.trigger) this.trigger.textContent = 'Not added';
      this.setStatus(typeof message === 'string' ? message : 'Not added. Try again.', 'is-error');
    }

    choiceText() {
      const el = this.querySelector('[data-ri-sticky-choice]');
      return el && !el.hidden ? el.textContent.trim() : '';
    }

    variantId() {
      const input = this.productForm?.querySelector('[name="id"]');
      return input ? String(input.value) : '';
    }

    refreshQty() {
      const token = (this._qtyToken = (this._qtyToken || 0) + 1);
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          if (token !== this._qtyToken) return;
          this.applyQty(cart);
        })
        .catch(() => {});
    }

    applyQty(cart) {
      const id = this.variantId();
      const line = cart && Array.isArray(cart.items) ? cart.items.find((row) => String(row.variant_id) === id) : null;
      const qty = line ? line.quantity : 0;
      this._lineKey = line ? line.key : '';
      this._qty = qty;
      const row = this.querySelector('[data-ri-sticky-qty]');
      const count = this.querySelector('[data-ri-sticky-count]');
      if (count) count.textContent = String(qty || 1);
      if (row) row.hidden = qty < 1;
      this.classList.toggle('is-in-cart', qty > 0);
      if (this.trigger) {
        this.trigger.hidden = qty > 0;
        if (qty > 0) this.classList.remove('is-pending');
        else if (this.defaultLabel) this.trigger.textContent = this.defaultLabel;
      }
      this.applyPad();
    }

    changeQty(delta) {
      if (this._pendingAdd || !this._lineKey) return;
      const next = Math.max(0, (this._qty || 0) + delta);
      this._pendingAdd = true;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: this._lineKey, quantity: next }),
      })
        .then((response) => response.json())
        .then((cart) => {
          this._pendingAdd = false;
          this._qtyToken = (this._qtyToken || 0) + 1;
          this.applyQty(cart);
          const link = document.getElementById('cart-icon-bubble');
          const slot = link && link.querySelector('.ri-header__cart-total');
          const label = link && link.querySelector('.ri-header__icon-label');
          if (slot && cart && window.RIMoney && window.RIMoney.formatCents) {
            if (!cart.item_count) {
              slot.hidden = true;
              slot.innerHTML = '';
              if (label) label.hidden = false;
            } else {
              slot.hidden = false;
              slot.innerHTML = window.RIMoney.formatCents(cart.total_price, '$');
              if (label) label.hidden = true;
            }
          }
        })
        .catch(() => {
          this._pendingAdd = false;
          this.setStatus('Not added. Try again.', 'is-error');
        });
    }

    /* One fixed pad for the bar's height, set once. It does not follow the bar in and out,
       so scrolling never re-measures or changes the page height. */
    applyPad() {
      const root = document.documentElement;
      const current = root.style.getPropertyValue('--ri-sticky-atc-pad');
      if (root.classList.contains('ri-sheet-open') || this.hidden) {
        if (current !== '0px') root.style.setProperty('--ri-sticky-atc-pad', '0px');
        return;
      }
      if (!this._padHeight) this._padHeight = Math.ceil(this.getBoundingClientRect().height);
      const next = `${this._padHeight}px`;
      if (current !== next) root.style.setProperty('--ri-sticky-atc-pad', next);
    }

    onScroll() {
      if (!this.buyButtons) {
        this.classList.add('is-visible');
        this.applyPad();
        return;
      }
      const rect = this.buyButtons.getBoundingClientRect();
      const past = rect.bottom < 0;
      this.classList.toggle('is-visible', past);
      this.applyPad();
    }

    onClick(event) {
      event.preventDefault();
      if (this._pendingAdd || (this._qty || 0) > 0) return;
      const submit =
        this.productForm?.querySelector('[type="submit"][name="add"]') ||
        this.productForm?.querySelector('[type="submit"]') ||
        document.querySelector('[id^="ProductSubmitButton"]');
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
        this.setStatus('Not added. This option is unavailable.', 'is-error');
        return;
      }
      this._pendingAdd = true;
      this.classList.add('is-pending');
      if (this.trigger) this.trigger.textContent = 'Adding...';
      this.setStatus('Adding ' + (this.choiceText() || 'this item') + '...', 'is-pending');
      submit.click();
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
